import "@market/market-theme/css/core/index.css";
import { c as m } from "../../index-PsWX3Tu1.js";
import { isValidElement as n, cloneElement as c } from "react";
import o from "./styles/MarketIcon.module.js";
const d = (l) => {
  const {
    baseSvg: r,
    className: s,
    multicolor: i,
    size: a = "medium",
    ...e
  } = l;
  if (!n(r))
    return null;
  const t = m(
    o.marketIcon,
    s,
    {
      [o.singleColor]: !i,
      [o[a]]: a
    }
  );
  return c(r, {
    "aria-hidden": e["aria-label"] === void 0 && e["aria-labelledby"] === void 0 ? !0 : void 0,
    className: t,
    fill: "currentColor",
    role: "img",
    ...e
  });
};
d.displayName = "MarketIconBase";
export {
  d as MarketIconBase
};
